export { s as setupSignals } from "./configure-C3x8YXzL.js";